import React from 'react'
import { OverrideScope } from '@/api/Wallet/Types/WithdrawalAutomationDto'
import { FormSelectField, FormSelectOption } from '@/components/Form/FormField'

import { parseScopeNumber, parseScopeString } from './overrideScope'

export interface ScopeOptions {
  companyOptions: FormSelectOption[]
  countryOptions: FormSelectOption[]
  paymentProviderOptions: FormSelectOption[]
  clientTypeOptions: FormSelectOption[]
  walletTypeOptions: FormSelectOption[]
}

interface Props {
  values: OverrideScope
  setFieldValue: (field: string, value: unknown) => void
  options: ScopeOptions
  readOnly?: boolean
}

const WILDCARD_PLACEHOLDER = 'All (wildcard)'

export const OverrideScopeFields: React.FC<Props> = ({
  values,
  setFieldValue,
  options,
  readOnly,
}) => {
  return (
    <>
      <FormSelectField
        name='tickmillCompanyId'
        label='Entity'
        value={values.tickmillCompanyId ?? undefined}
        options={options.companyOptions}
        allowClear
        showSearch
        readOnly={readOnly}
        placeholder={WILDCARD_PLACEHOLDER}
        onChange={(value) => setFieldValue('tickmillCompanyId', parseScopeNumber(value))}
      />
      <FormSelectField
        name='countryId'
        label='Country'
        value={values.countryId ?? undefined}
        options={options.countryOptions}
        allowClear
        showSearch
        readOnly={readOnly}
        placeholder={WILDCARD_PLACEHOLDER}
        onChange={(value) => setFieldValue('countryId', parseScopeString(value))}
      />
      <FormSelectField
        name='paymentProviderId'
        label='PSP / Method'
        value={values.paymentProviderId ?? undefined}
        options={options.paymentProviderOptions}
        allowClear
        showSearch
        readOnly={readOnly}
        placeholder={WILDCARD_PLACEHOLDER}
        onChange={(value) => setFieldValue('paymentProviderId', parseScopeString(value))}
      />
      <FormSelectField
        name='clientTypeId'
        label='Client Type'
        value={values.clientTypeId ?? undefined}
        options={options.clientTypeOptions}
        allowClear
        readOnly={readOnly}
        placeholder={WILDCARD_PLACEHOLDER}
        onChange={(value) => setFieldValue('clientTypeId', parseScopeNumber(value))}
      />
      <FormSelectField
        name='walletTypeId'
        label='Wallet Type'
        value={values.walletTypeId ?? undefined}
        options={options.walletTypeOptions}
        allowClear
        readOnly={readOnly}
        placeholder={WILDCARD_PLACEHOLDER}
        onChange={(value) => setFieldValue('walletTypeId', parseScopeNumber(value))}
      />
    </>
  )
}
